import * as BrowserFeatures from '@Stores/BrowserFeatures';
import usePage from '@Queries/usePage';
import getCookie from '@Utils/getCookie';
import DiscountSubscriptionPopupTimer from '../DiscountSubscriptionPopupTimer';

import type { FC } from 'react';

const visibleForPages = ['Index'];

const DiscountSubscriptionPopupLoader: FC = () => {
  const browserFeatures = BrowserFeatures.useBrowserFeaturesStore();
  const page = usePage();
  const wasClosed = getCookie('discount_banner_closed') === 'closed';
  const wasSuccess = browserFeatures.isLocalStorageAvailable
    ? localStorage.getItem('discount_banner_closed') === 'closed'
    : false;
  const visible = visibleForPages.includes(page.data?.page);

  return visible && !wasClosed && !wasSuccess ? <DiscountSubscriptionPopupTimer /> : null;
};

export default DiscountSubscriptionPopupLoader;
